import React, { useState } from "react";
import PageInfoAndActionBar from "../../../../Layouts/PageInfoAndActionBar";
import BuilderModal from "../../../../Layouts/Modal/BuilderModal";
import NotesAndTags from "../../../../components/BuilderComponents/NotesAndTags";
import AccessTemplateSelection from "../../../../components/BuilderComponents/AccessTemplateSelection";
import { useAppBlocksContext } from "../../../../context/AppBlocksContext";
import { useAxiosContext } from "../../../../context/AxiosContext";
import { useAuth0Context } from "../../../../context/Auth0Context";
import MultiRadio from "../../../../components/FormComponents/MultiRadio";
import { toastError } from "../../../../utils/toastUtils";

const RecordviewPageActionsHandler = () => {
  const {
    blockData,
    blockDataDispatch,
    lockData,
    setLockData,
    handleCloneApplicationBlock,
    handleSaveApplicationBlock,
    layout,
    layoutData,
    nestedGridData
  } = useAppBlocksContext();
  const { axiosInstance, handleSuccess } = useAxiosContext();
  const { user } = useAuth0Context();

  const initialModalState = {
    show: false,
    type: ""
  };
  const [isModalOpen, setIsModalOpen] = useState(initialModalState);

  const closeModal = () => {
    setIsModalOpen(initialModalState);
  };

  const handleNotesAndTag = (data, keyName) => {
    if (keyName === "info_tag") {
      blockDataDispatch({ type: "INFO_TAG", payload: data }); //info_tag description
    }
    if (keyName === "description") {
      blockDataDispatch({ type: "DESCRIPTION", payload: data });
    }
  };

  const handleChangeRvSize = (e) => {
    blockDataDispatch({ type: "RECORDSVIEW_SIZE", payload: e.target.value });
  };

  const handleAccessTemplate = (data) => {
    blockDataDispatch({ type: "ACCESS_TEMPLATES", payload: data });
  };

  const handletoggleLock = async () => {
    try {
      if (lockData && lockData.user_id) {
        if (lockData.user_id !== user.sub) {
          toastError("Unauthorized");
          return;
        }
        const { message } = await axiosInstance.delete(`/app/lock/${blockData.id}`);
        handleSuccess(message);
        setLockData({});
      } else {
        const userinfo = `${user.first_name} (${user.email})`;
        const lock = {
          type: "recordview",
          user_id: user.sub,
          user_info: userinfo,
          type_id: blockData.id,
          type_name: blockData.name
        };
        const { message } = await axiosInstance.post(`/app/lock`, lock);
        handleSuccess(message);
        setLockData(lock);
      }
    } catch (error) {
      console.error("API call failed", error);
    }
  };

  const sizeOptions = [
    { id: "", name: "Default" },
    { id: "small", name: "small" },
    { id: "medium", name: "medium" },
    { id: "large", name: "large" }
  ];

  return (
    <>
      <PageInfoAndActionBar
        pagePath={`Recordsview`}
        toggleLock={handletoggleLock}
        clonePage={handleCloneApplicationBlock}
        savePage={handleSaveApplicationBlock}
        currentConfig={[blockData, layout, layoutData.current, nestedGridData.current]}
        pageName="applicationblock"
        notesPage={() => setIsModalOpen({ show: true, type: "note" })}
        isLocked={lockData?.user_id || null}
        settingPage={() => setIsModalOpen({ show: true, type: "access_template" })}
      />
      <BuilderModal
        isOpen={isModalOpen.show}
        onClose={closeModal}
        modalName={isModalOpen.type === "access_template" ? "Select Access Template" : "Add Note and Tags"}
      >
        {isModalOpen.type === "note" && (
          <NotesAndTags
            notesValue={blockData.description || ""}
            tagValue={blockData.info_tag || []}
            onChange={handleNotesAndTag}
          />
        )}
        {isModalOpen.type === "access_template" && (
          <div className="builder_form">
            <AccessTemplateSelection templates={blockData.access_templates} handleChange={handleAccessTemplate} />
            <MultiRadio
              keyName="size"
              selectedValue={blockData.recordsview_settings?.size || ""}
              options={sizeOptions}
              onChange={handleChangeRvSize}
              label="Recordsview Size"
            />
          </div>
        )}
      </BuilderModal>
    </>
  );
};

export default RecordviewPageActionsHandler;
